// cspell:disable
import { idFormat, type ID } from "@redotech/redo-ids-cockroach";

export type NotificationId = ID<"notification">;
export const notificationIdFormat = idFormat<NotificationId>({
  prefix: "ntf_",
});
